const initialState = {
  data: {
    token: null,
    user: null,
    loggedIn: false,
  },
}

export default initialState;
